// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"4e7abb69","864":"1954f048"}[chunkId] + ".chunk.js";
};